import React, { Component } from 'react'
import SectionControls from 'components/controls/section-controls'
import Note from '../project-notes/project-note'
import AlertBanner from 'components/alerts/alert-banner'

import { 
	withRouter,
	Prompt
} from 'react-router'

import copy from 'fast-copy'
import isEqual from 'react-fast-compare'

import { connect } from 'react-redux'
import { 
	getMeetings,
	addMeeting,
	saveMeeting,
	getStakeholdersAndPurposes,
	openModal
} from 'state/actions'

import DropdownMenu from 'components/dropdown-menu/dropdown-menu'
import InputStandard from 'components/input/standard'
import DateContainer from 'components/date-container/date-container'
import TagsInput from 'components/input/tags'
import QuillWysiwyg from 'components/input/quill-wysiwyg'

import FlipMove from 'react-flip-move'
import moment from 'moment'

import Button from 'components/button/button'

import { MainContext } from 'context'

import Loader from 'components/loader/loader'

import { getUrlParams, doSort } from 'utils'

import ProjectTasksList from '../project-tasks/list/project-tasks-list'

class ProjectMeetings extends Component {
	meetings = []
	meetingMilestone = []

	state = {
		currentMeeting: null,
		openMenu: null,
		isLoading: true,
		isPristine: true,
		isSaving: false,
		clearRandomNumber: 0 // This is fucking dumb, but react-draft won't know to reset, otherwise
	}

	UNSAFE_componentWillMount() {
		const {
			getStakeholdersAndPurposes,
			currentProject,
			getMeetings
		} = this.props

		getStakeholdersAndPurposes(this.context.account.id)

		if(currentProject){
			getMeetings(currentProject.id, _ => {
				this.setState({
					isLoading: false
				})

				this.changeMeeting()
			})
		}
	}

	UNSAFE_componentWillUpdate = nextProps => {
		// this randomly goes, but never returns. SIGHHH
		if(this.props.currentProject && this.props.currentProject.id !== nextProps.currentProject.id){
			getMeetings(nextProps.currentProject.id, _ => {
				this.setState({
					isLoading: false
				})

				this.changeMeeting()
			})
		}
	}
	
	componentDidUpdate = prevProps => {
		const hadMeetings = (prevProps.currentProject.meetings && prevProps.currentProject.meetings.length)
		const hasMeetings = (this.props.currentProject.meetings && this.props.currentProject.meetings.length)

		if(!hadMeetings && hasMeetings){
			return this.changeMeeting()
		}

		if(hadMeetings && hasMeetings && hasMeetings > hadMeetings){
			return this.changeMeeting()
		}

		if(this.state.currentMeeting){
			const currentMeetingId = this.state.currentMeeting.id

			if(this.props.currentProject.meetings.indexOf(currentMeetingId) === -1){
				this.changeMeeting()
			}
		}
	}

	addMeeting = _ => {
		this.props.addMeeting(this.props.currentProject.id, _ => {})
	}

	changeMeeting = meetingId => {
		const {
			currentProject,
			allMeetings
		} = this.props

		if(!currentProject.meetings){
			return
		}

		let meeting = null

		if(!meetingId){
			const meetingParamIfAny = getUrlParams('meeting')

			if(meetingParamIfAny && parseInt(meetingParamIfAny)){
				const isInProject = this.meetings.indexOf(parseInt(meetingParamIfAny)) !== -1

				if(isInProject){
					meetingId = meetingParamIfAny
				}
			}

			if(!meetingId){
				meetingId = this.meetings.length ? this.meetings[0].id : null
			}
		}

		if(meetingId){
			meeting = allMeetings[meetingId]
		}

		if(meeting){
			this.setState({
				currentMeeting: copy(meeting),
				isPristine: true
			})
		}else{
			return null
		}
	}

	handleChange = (type, key, value) => {
		if(key == 'stakeholder_id' && value == -1){
			return this.props.openModal('add','stakeholder', {
				isMini: true,
				onComplete: stakeholder => {
					if(stakeholder && stakeholder.id){
						this.setState({
							currentMeeting: {
								...this.state.currentMeeting,
								stakeholder_id: stakeholder.id
							}
						})
					}
				}
			})
		}

		const currentMeeting = copy(this.state.currentMeeting)

		let hasChanged = true

		if(type == 'text'){
			const currentValue = currentMeeting[key] ? currentMeeting[key] : '<p></p>'

			if(currentValue.replace(/\n|\r/g, "") == value.replace(/\n|\r/g, "")){
				hasChanged = false
			}
		}

		switch(type){
			case 'select':
			case 'tags':
			case 'text':
				currentMeeting[key] = value
				break
			case 'date':
				currentMeeting[key] = moment(value).format('Y-MM-DD')
				break
		}

		if(hasChanged){
			this.setState({
				currentMeeting,
				openMenu: null,
				isPristine: false
			})
		}
	}

	deleteMeeting = _ => {
		this.props.openModal('delete', 'meeting', this.state.currentMeeting)
	}

	toggleMenuCallback = key => {
		this.setState({
			openMenu: this.state.openMenu == key ? null : key
		})
	}

	saveMeeting = _ => {
		this.setState({
			isSaving: true
		})

		this.props.saveMeeting({
			...this.state.currentMeeting,
			purposes: this.getStringsFromTags(),
			stakeholders: this.getStringsFromStakeholders()
		}, _ => {
			this.setState({
				isSaving: false,
				isPristine: true
			})
		})
	}

	cancelEdit = _ => {
		const currentMeetingId = this.state.currentMeeting.id

		this.setState({
			clearRandomNumber: (this.state.clearRandomNumber + 1)
		})

		this.changeMeeting(currentMeetingId)
	}

	getStringsFromTags = _ => {
		const {
			allPurposes
		} = this.props

		const {
			currentMeeting
		} = this.state

		const tags = []

		if(currentMeeting){		
			currentMeeting.purposes && currentMeeting.purposes.forEach(purposeOrId => {
				if(typeof purposeOrId == 'number'){
					const tag = allPurposes[purposeOrId]

					tags.push(tag.name)
				}else{
					tags.push(purposeOrId)
				}
			})
		}

		return tags
	}

	getStringsFromStakeholders = _ => {
		const {
			allStakeholders
		} = this.props

		const {
			currentMeeting
		} = this.state

		const stakeholders = []

		if(currentMeeting){
			currentMeeting.stakeholders && currentMeeting.stakeholders.forEach(stakeholderOrId => {
				if(typeof stakeholderOrId === 'number'){
					const stakeholder = allStakeholders[stakeholderOrId]

					stakeholders.push(stakeholder.organisation_name)
				}else{
					stakeholders.push(stakeholderOrId)
				}
			})
		}

		return stakeholders
	}

	getAllPurposes = _ => {
		const {
			allPurposes
		} = this.props

		const purposes = []

		this.context.account.purposes && this.context.account.purposes.forEach(purposeId => {
			const purpose = allPurposes[purposeId]

			if(purpose){
				purposes.push(purpose)
			}
		})

		return purposes
	}

	getAllStakeholders = _ => {
		const stakeholders = []

		const {
			account
		} = this.context

		const {
			allStakeholders
		} = this.props

		account.stakeholders && account.stakeholders.forEach(stakeholderId => {
			const stakeholder = allStakeholders[stakeholderId]
			
			if(stakeholder){
				stakeholders.push({
					...stakeholder,
					name: stakeholder.first_name ? stakeholder.first_name : stakeholder.organisation_name // just so it can sort correctly
				})
			}
		})

		stakeholders.unshift({
			name: 'Add new...',
			id: -1
		})

		return stakeholders
	}

	getMeetingMilestone = _ => {
		const milestoneArray = []

		const {
			currentMeeting
		} = this.state
		
		const {
			allMilestones,
			allTasks
		} = this.props

		if(currentMeeting && currentMeeting.milestone){
			const milestone = copy(allMilestones[currentMeeting.milestone])

			if(milestone){
				const tasks = []

				milestone.tasks && milestone.tasks.forEach(taskId => {
					const task = allTasks[taskId]
					
					if(task){
						tasks.push(task)
					}
				})

				milestoneArray.push({
					...milestone,
					tasks
				})
			}
		}

		if(!isEqual(this.meetingMilestone, milestoneArray)){
			this.meetingMilestone = milestoneArray
		}
	}

	render() {
		const {
			currentMeeting,
			openMenu,
			isPristine,
			isSaving,
			isLoading,
			clearRandomNumber
		} = this.state

		const {
			currentProject,
			allMeetings,
			applicableUsers,
			match
		} = this.props

		const {
			user
		} = this.context

		this.meetings = []

		if(currentProject && currentProject.meetings){
			currentProject.meetings.forEach(meetingId => {
				const meetingObject = allMeetings[meetingId]

				if(meetingObject){
					this.meetings.push(meetingObject)
				}
			})
		}

		this.meetings = doSort(this.meetings, 'date', 'start_date', true)

		const buttonProps = [
			{
				size: 'big',
				level: 'high',
				callback: this.addMeeting,
				label: 'Add new meeting',
				icon: 'fe-edit-2',
			},
			{
				size: 'big',
				level: 'low',
				callback: this.deleteMeeting,
				label: 'Delete meeting',
				icon: 'fe-trash-2',	
				disabled: !this.meetings.length,
			}
		]

		const formFieldRows = [
			[
				{
					label: 'Start date',
					type: 'date',
					placeholder: 'Select a date',
					key: 'start_date'
				},
				{
					label: 'Location',
					key: 'location',
					type: 'text',
					placeholder: 'Type a location'
				},
				{
					label: 'Organiser',
					type: 'select',
					parentType: 'stakeholder',
					key: 'stakeholder_id',
					valueKey: 'person_and_organisation_name',
					placeholder: 'Please select',
					values: this.getAllStakeholders(),
				}
			],
			[
				{
					label: 'Type of contact',
					type: 'select',
					key: 'contact_type_id',
					parentType: 'contact type',
					placeholder: 'Please select',
					values: this.context.account.contact_types ? doSort(this.context.account.contact_types, 'alpha', 'name') : []
				},
				{
					label: 'Meeting purposes',
					key: 'purposes',
					parentType: 'purpose',
					type: 'tags',
					valueKey: 'name',
					values: this.getAllPurposes(),
					value: this.getStringsFromTags()
				}
			],
			[
				{
					label: 'Number of attendees',
					type: 'text',
					key: 'number_of_attendees',
					placeholder: 'Enter a number'
				},
				{
					label: 'Organisations in attendance',
					key: 'stakeholders',
					parentType: 'stakeholder',
					type: 'tags',
					valueKey: 'organisation_name',
					values: this.getAllStakeholders(),
					value: this.getStringsFromStakeholders()
				}
			],
			[
				{
					label: 'Notes',
					type: 'wysiwyg',
					key: 'notes'
				}
			]
		]

		this.getMeetingMilestone()

		return (
			<div>
				<Prompt 
                    when={!isPristine}
                    message={`This meeting has unsaved data. Leave anyway?`}
                />
				<div className="page-column-main">
					<SectionControls 
						noSearch={true} 
						buttons={buttonProps} 
					/>
					{ (!this.meetings.length || !currentMeeting) ?
						<div>
							{ isLoading ? 
								<div className="meeting-form box loading">
									<Loader visible={true} />
								</div>
							:
								<AlertBanner
									title="This project has no meetings"
									body="Add a new meeting to get started."
								/> 
							}
						</div>
						:
						<div className="meeting-form box" 
							onSubmit={e => {
								e.preventDefault()
							}}
						>
							{ formFieldRows.map((row, index) => {
								let className = 'form-row columns-'+row.length

								return (
									<div 
										className={className} 
										key={index}
									>
										{ row.map(column => {
											let Component = null
											let props = {}

											switch(column.type){
												case 'text':
													Component = InputStandard

													props = {
														outlineOnFocus: false,
														callback: _ => {},
														onChange: e => this.handleChange(column.type, column.key, e.target.value),
														value: currentMeeting[column.key] ? currentMeeting[column.key] : '',
														placeholder: column.placeholder
													}
													break
												case 'date':
													Component = DateContainer

													props = {
														isEdit: true,
														isOpen: openMenu == column.key,
														toggleCallback: _ => this.toggleMenuCallback(column.key),
														selectCallback: date => this.handleChange(column.type, column.key, date),
														initialMonth: new Date(),
														selectedDate: currentMeeting[column.key] ? moment(currentMeeting[column.key]).format('Y-MM-DD') : null,
														closeCallback: _ => this.toggleMenuCallback(column.key),
														allowPast: true
													}
													break
												case 'select':
													Component = DropdownMenu

													props = {
														parentType: column.parentType,
														parentKey: null,
														isObjects: true,
														selectableItems: doSort(column.values, 'alpha', 'name'),
														selectedItemId: currentMeeting[column.key],
														handleChange: id => this.handleChange(column.type, column.key, id),
														hasSearch: true,
														valueKey: column.valueKey
													}

													break
												case 'tags':
													Component = TagsInput

													props = {
														existingTags: column.values,
														onChange: tags => this.handleChange(column.type, column.key, tags),
														value: column.value,
														parentType: column.parentType,
														valueKey: column.valueKey
													}
													break
												case 'wysiwyg':
													Component = QuillWysiwyg

													props = {
														isVisible: true,
														canEdit: true,
														onChange: value => this.handleChange('text', column.key, value),
														value: currentMeeting[column.key] ? currentMeeting[column.key] : '<p></p>',
														mentions: [],// availableMentions,
														objectId: currentMeeting.id,
														clearRandomNumber,
														placeholder: "Write general notes here, e.g contact details, meeting minutes or feedback.",
														thisUser: user,
														objectId: currentMeeting.id,
														context: 'comment'
													}
													break
											}

											if(!Component){
												return null
											}

											return (
												<div key={column.key} className="column">
													<label>
														{ column.label }
													</label>
													<div>
														<Component {...props} />
													</div>
												</div>
											)
										}) }
									</div>
								)
							})}
							<div className="button-row">
								<Button
									label="Save meeting"	
									disabled={isPristine}
									icon="check"
									size="big"
									level="high"
									callback={this.saveMeeting}
									isLoading={isSaving}
								/>
								<Button
									label="Cancel changes"	
									disabled={isPristine}
									icon="ban"
									size="big"
									level="low"
									callback={this.cancelEdit}
								/>
							</div>
						</div>
					}
					{ currentMeeting ?
						<ProjectTasksList
							ref={"listRef"}
							milestonesArray={this.meetingMilestone}
							draggedItemType={null}
							draggedItemId={null}
							isDragging={false}
							menuState={{}}
							match={match}
							currentFocusedTask={null}
							currentProject={currentProject}
							applicableUsers={applicableUsers}
							isPremium={false}
							isMini={true}
							userData={user}
						/>
					: null }
				</div>
				<div className="page-column-aside">
					<ul>
						<FlipMove 
							duration={250} 
							easing="ease-out"
							enterAnimation="accordionVertical" 
							leaveAnimation="accordionVertical"
						>
							{ this.meetings.map((meeting, i) => {
								let thisMeeting = meeting
								let isCurrent = false

								if(currentMeeting && currentMeeting.id == meeting.id){
									thisMeeting = currentMeeting
									isCurrent = true
								}

								return (
									<Note 
										key={meeting.id}
										note={thisMeeting}
										isCurrent={isCurrent} 
										changeNote={this.changeMeeting} 
										deleteNote={this.deleteMeeting}
										canDelete={true}
										meeting={meeting}
									/>
								)
							})}
						</FlipMove>
					</ul>
				</div>
			</div>
		)
	}
}

const mapStateToProps = state => {
	return {
		allMeetings: state.account.entities.meetings,
		allUsers: state.account.entities.users,
		allStakeholders: state.account.entities.stakeholders,
		allPurposes: state.account.entities.purposes,
		allMilestones: state.account.entities.milestones,
		allTasks: state.account.entities.tasks
	}
}

export default withRouter(connect(mapStateToProps, {
	getMeetings,
	addMeeting,
	saveMeeting,
	getStakeholdersAndPurposes,
	openModal
})(ProjectMeetings))

ProjectMeetings.contextType = MainContext